// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1rnr0","colMin":"styles_colMin__18yfr","colCheckbox":"styles_colCheckbox__1KlQV"};